export default __webpack_public_path__ + "static/media/pulse_login_logo.8e45e7f1.svg";